// Cross-page handoff for "fire confetti when the user lands on their newly
// published listing." Keyed by listing id so the celebration can never fire
// on the wrong page, and consumed exactly once.
//
// sessionStorage (not in-memory) so it survives the Ionic page transition
// even if the publish form unmounts before the detail page mounts.

const KEY_PREFIX = 'just-published:';

export function markJustPublished(listingId: string) {
  try {
    sessionStorage.setItem(KEY_PREFIX + listingId, '1');
  } catch {
    // sessionStorage can be unavailable in private-browsing edge cases;
    // missing confetti is not worth crashing the publish flow.
  }
}

/** Returns true and clears the flag if this listing was just published. */
export function consumeJustPublished(listingId: string): boolean {
  try {
    const key = KEY_PREFIX + listingId;
    const v = sessionStorage.getItem(key);
    if (v) {
      sessionStorage.removeItem(key);
      return true;
    }
  } catch {
    // ignore
  }
  return false;
}
